import React from 'react';
import Maps from './Maps';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';

const About = props => (
	<section className="contact" id="contact">
		<Container>
			<div className="address-box">
		     <Row>
			    <Col xs={12} md={{ span: 4, offset: 1 }} className="center">
			    	<div className="">
				    	<h5 className="contact-title">Coveris Rypin Sp. z o.o.<br/>
							BIURO ZARZĄDU</h5>
				    	<p className="">	    	
				    		87-500 Rypin, ul. Polna 2<br/>
							tel. +48 54 280 6250<br/>
							NIP 892-145-49-58<br/>
							REGON 340466703<br/>
							KRS 0000309188
				    	</p>
				    	<h5 className="contact-title">BIURO HANDLOWE /<br/>
							CENTRUM LOGISTYCZNE</h5>
				    	<p className="">	    	
				    		87-500 Rypin, ul. Bielawki 18<br/>
							tel. +48 54 280 2143<br/>
							fax +48 54 280 6251<br/>
							rypin@coveris.com
				    	</p>
				    </div>
			    </Col>
			    <Col xs={12} md={{ span: 5, offset: 2 }} className="center">
			    	<div className="">
				    	<h5 className="contact-title">DZIAŁ GRAFICZNY</h5>
				    	<p className="">	    	
				    		tel. +48 509 350 322<br/>
							tel. +48 510 093 577<br/>
							rypin.graficy@coveris.com
				    	</p>
				    	<h5 className="contact-title">DZIAŁ KSIĘGOWOŚCI</h5>
				    	<p className="">	    	
				    		tel. +48 510 093 677<br/>
				    	</p>
				    	<h5 className="contact-title">DZIAŁ LOGISTYKI</h5>
				    	<p className="">	    	
				    		tel. +48 54 280 21 43<br/>
							tel. +48 506 706 528<br/>
							rypin.logistyka@coveris.com
				    	</p>
				    </div>
			    </Col>
		  	 </Row>
		  	</div>

		  	 <Row>
		  	 
		  	 	<Col xs={12} md={12} className="box-map">
					<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2397.451411024399!2d19.432046369158545!3d53.0661638482933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ce45abcfe6123%3A0xf43bb3f125abbbd7!2sPolna%202%2C%2087-500%20Rypin!5e0!3m2!1spl!2spl!4v1743754025085!5m2!1spl!2spl" height="450" style={{border: 0, width: '100%'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
		  	 	</Col>
			  	{/*<Col xs={12} md={6}>
			  		<Form>
					  <Form.Row>
					    <Col>
					      <Form.Control placeholder="Nazwa firmy" />
					    </Col>
					    <Col>
					      <Form.Control placeholder="Imię i nazwisko" />
					    </Col>
					  </Form.Row>
					  <Form.Row>
					    <Col>
					      <Form.Control placeholder="Adres e-mail" />
					    </Col>
					    <Col>
					      <Form.Control placeholder="Numer telefonu" />
					    </Col>
					  </Form.Row>
					   <Form.Group>
					    <Form.Control as="textarea" placeholder="Treść wiadomości" rows="5" />
					  </Form.Group>
					  <Form.Group className="center">
					 	 <Button type="submit">Wyślij</Button>
					  </Form.Group>
					</Form>
			  	</Col>*/}
		  	 </Row>
		</Container>
	</section>
);

export default About;
